import { Component, OnInit } from '@angular/core';
import { MasterDataService } from './../../../services/master-data.service';
import { IndependenceModel } from 'src/app/analytic-report/declaration.model';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-my-annual',
  templateUrl: './my-annual.component.html',
  styleUrls: ['./my-annual.component.css'],
})
export class MyAnnualComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  reportList;
  annualIndependence: IndependenceModel;
  constructor(private masterDataService: MasterDataService,
    private commonMessageService:CommonMessageService) {}

  ngOnInit(): void {
    this.selectedFinancialYear="";
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }
  onViewReport() {
    if(this.selectedFinancialYear==undefined||this.selectedFinancialYear==""||this.selectedFinancialYear==null){
      this.commonMessageService.swalAlertWithoutIcon('','Please Select Financial Year.');
      return;
    }
    this.masterDataService
      .getAnnualIndependence(
        this.selectedFinancialYear.id,
        localStorage.getItem('id'),
        1
      )
      .subscribe((res) => {
        this.annualIndependence = res;
        console.log("annualIndependence",this.annualIndependence)
        if(this.annualIndependence==null){
          this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
        }
      });
  }
}
